import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-switch-button-with-description',
  templateUrl: './switch-button-with-description.component.html',
})
export class SwitchButtonWithDescriptionComponent implements OnInit {
  @Input() prefix?: string;
  @Input() strictValueKey?: string;
  @Input() value?: string;

  @Output() valueChange: EventEmitter<string> = new EventEmitter<string>();

  typeDescription: string = null!;

  constructor() {}

  ngOnInit(): void {}

  setAssessmentTypeDescription(value: string): void {
    this.typeDescription = this.prefix + '.' + value;
  }

  onValueChange(value: string): void {
    this.valueChange.emit(value);
    this.setAssessmentTypeDescription(value);
  }
}
